import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import trTranslations from './locales/tr.json';
import deTranslations from './locales/de.json';
import frTranslations from './locales/fr.json';
import ruTranslations from './locales/ru.json';
import arTranslations from './locales/ar.json';

const resources = {
  en: { translation: enTranslations },
  tr: { translation: trTranslations },
  de: { translation: deTranslations },
  fr: { translation: frTranslations },
  ru: { translation: ruTranslations },
  ar: { translation: arTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'tr', 'de', 'fr', 'ru', 'ar'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
